module.exports = __webpack_public_path__ + "img/ryzhkov_vasyl_3.9a74a05a.png";